import { render, staticRenderFns } from "./ProductDisplay.vue?vue&type=template&id=1a26c04e"
import script from "./ProductDisplay.vue?vue&type=script&lang=js"
export * from "./ProductDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports